import { render, staticRenderFns } from "./DownloadPrev.vue?vue&type=template&id=bb5d1200&scoped=true"
import script from "./DownloadPrev.vue?vue&type=script&lang=js"
export * from "./DownloadPrev.vue?vue&type=script&lang=js"
import style0 from "./DownloadPrev.vue?vue&type=style&index=0&id=bb5d1200&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5d1200",
  null
  
)

export default component.exports